import { call, put, takeLatest } from 'typed-redux-saga'
import { userLeadApi, UserLeadNS, userLeadSlice } from 'Pages/user'
import { errorHandler } from 'Modules'
import { leadOneSlice, RbidosLeadModel } from 'Pages/lead'
import { Deserialize } from 'cerialize'
import { takeEveryUnique } from 'Src/helpers'

function* recreateLead(action: UserLeadNS.RecreateLead) {
	try {
		const { data, callback } = action.payload
		const res = yield* call(userLeadApi.recreateEmail, data)
		yield* put(leadOneSlice.actions.setOne(Deserialize(res, RbidosLeadModel)))
		callback?.()
	} catch (error) {
		const { formName } = action.payload
		yield* call(errorHandler, error, formName)
	}
}

function* updateUserLeadType(action: UserLeadNS.UpdateUserLeadType) {
	try {
		const { id, data, callback } = action.payload
		yield* call(userLeadApi.updateUserLeadType, id, data)
		callback?.()
	} catch (error) {
		yield* call(errorHandler, error)
	}
}

export const userLeadSaga = function* saga() {
	yield* takeEveryUnique(userLeadSlice.actions.recreateLead.type, recreateLead)
	yield* takeLatest(userLeadSlice.actions.updateUserLeadType.type, updateUserLeadType)
}
